export default __webpack_public_path__ + "static/media/lock_icon.bf1e83a6.svg";